import React from 'react';

export function NonAuthSidebar() {
  return (
    <div className="flex flex-col justify-center items-center h-full w-1/2 p-2 relative">
      <div className="w-full h-full rounded-2xl p-5 bg-[#B6DAFF]">
        <div className="flex absolute z-10 top-1/5 pt-4 w-2/3 right-4">
          <img src="/images/company/landingimage.png" alt="landingImage" />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center w-full h-full absolute z-10 px-16 py-20">
        <img
          className="mb-16"
          style={{ height: '72px' }}
          src="/images/company/logoGrp.png"
          alt="Company Logo"
        />
        <p className="text-5xl mb-8 text-txt-primary font-medium text-center">
          AI Voice Agents for
          <br />
          your healthcare
          <br />
          practice.{' '}
        </p>
        <p className="text-xl font-normal text-txt-primary text-center">
          Healthcare AI that frees teams to focus on care.
          <br /> Improve patient engagement and overcome
          <br /> staffing shortages.
        </p>
      </div>
    </div>
  );
}
